
import React, { Component } from "react";
import { loginFetch, limpiarLogin } from "../../redux/actions/aLogin";
import { connect } from "react-redux";
import { encriptarTrama, encriptarContrasenia } from "../../utils/Encriptar";
import Login from "../../components/Login/AuthForm";
import { Card, Col, Row } from "reactstrap";
import "../../styles/estilos.css";
import "../../components/Login/login.css";
import { withRouter } from "react-router-dom";
import logo from "assets/img/logo/logo_aig_login-2.png";
import LoadingScreen from "react-loading-screen";
import muneca from "assets/img/login/muneca2.png";
import { empresa } from "../../constants";
import { plataforma, plataforma1 } from "../../constants/urls";
//import logoMuneca from "assets/img/login/logo-aig-login.png";

var mensaje = "Error al iniciar sessión. Inténte de nuevo"
class ContainerLogin extends Component {
  constructor(props) {
    super(props);
    this.onChangeFormulario = this.onChangeFormulario.bind(this);
    let usr = {
      usrCorreo: "",
      usrContrasena: ""
    };
    this.state = {
      usrModificado: usr,
      showScreens: "login",
      user: {},
      open: false,
      vacios: false,
    };
  }
  show = () => this.setState({ open: true });
  handleConfirm = () => {
    if (this.state.recuperar) this.setState({ open: false, recuperar: false });
    else this.setState({ open: false });
  };

  handleIniciarSesion = (param) => {
    //console.log("Parametros login ", param);

    // const hasNameError = param.hasNameError;
    // const hasContrasenaError = param.hasContrasenaError;
    let usr = this.state.usrModificado;
    usr.usrCorreo = param.correo;
    usr.usrContrasena = param.contrasenia;
    //console.log("datos pasar", usr);
    this.setState({ usrModificado: usr });

    this.iniciarSesion(0);
  };

  handleCambiarContrasenia = async value => {
    this.props.history.push({
      pathname: `/cambiar-contrasenia`
    });
  };

  async iniciarSesion(encrypted64Login) {
    if (encrypted64Login === 0) {
      let dataLogin = {};
      dataLogin = {
        cliUsuario: this.state.usrModificado.usrCorreo,
        cliPassword: encriptarContrasenia(this.state.usrModificado.usrContrasena),
        carHash: ""
      };

      dataLogin = JSON.stringify(dataLogin);
      //console.log("datalogin ", dataLogin);
      encrypted64Login = encriptarTrama(dataLogin);
    }
    await this.props.loginUsuario({
      empresa: empresa,
      plataforma: plataforma1,
      data: encrypted64Login
    });

    setTimeout(() => {
      console.log('realizo el inicio', this.props.datosUsuario.dataUsuario)
      if (this.props.datosUsuario.dataUsuario.userIsLoggedIn) {
        this.funcionPush()
      }
    }, 500)



    //this.funcionPush();
  }

  funcionPush() {

    //console.log("\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\Redireccionar///////////////////////////////", this.props);
    //this.props.history.replace("/cotizacion?accion=nuevo");
    //Verificar si proviene de pago 
    const queryParams = new URLSearchParams(this.props.location.search);
    let from = queryParams.get('from');
    let accion = queryParams.get('accion');
    if (from !== undefined && from === 'pago') {
      const queryParams = new URLSearchParams(this.props.location.search);
      let id = queryParams.get('id');
      let estado = queryParams.get('estado');
      this.props.history.replace({
        pathname: `/final-cotizacion`,
        search: `?id=${id}&estado=${estado}`
      });
    }
    else if (accion !== undefined && accion === "nuevo") {
      this.props.history.replace("/cotizacion?accion=nuevo");
    }
    else if (this.props.location.state && this.props.location.state.prevLocation)
      this.props.history.replace(this.props.location.state.prevLocation);
    else
      this.props.history.replace("/principal");

  }

  componentDidMount = () => {
    //console.log("////////////", this.props.datosUsuario.dataUsuario.userIsLoggedIn, this.props);
    let logIn = this.props.datosUsuario.dataUsuario === undefined ? false : this.props.datosUsuario.dataUsuario.userIsLoggedIn;

    if (!logIn) {
      //console.log("*******************************Me quedo en login1****************-*********");
      const queryParams = new URLSearchParams(this.props.location.search);
      let from = queryParams.get('from');
      if (from) {
        if (from === 'home') {
          this.props.history.replace("/");
        }
      }
      this.props.limpiarDatos();
    } 
    else {
      this.props.history.replace("/");
    }

    // } else {
    //   console.log("\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\Redireccionar///////////////////////////////", this.props);
    //   //this.props.history.replace("/cotizacion?accion=nuevo");
    //   //Verificar si proviene de pago 
    //   const queryParams = new URLSearchParams(this.props.location.search);
    //   let from = queryParams.get('from');
    //   let accion = queryParams.get('accion');
    //   if (from !== undefined && from === 'pago') {
    //     const queryParams = new URLSearchParams(this.props.location.search);
    //     let id = queryParams.get('id');
    //     let estado = queryParams.get('estado');
    //     this.props.history.replace({
    //       pathname: `/final-cotizacion`,
    //       search: `?id=${id}&estado=${estado}`
    //     });
    //   }
    //   else if (accion !== undefined && accion === "nuevo") {
    //     this.props.history.replace("/cotizacion?accion=nuevo");
    //   }
    //   else if (this.props.location.state && this.props.location.state.prevLocation)
    //   this.props.history.replace(this.props.location.state.prevLocation);
    // else
    //   this.props.history.replace("/principal");
    // }
  };

  onChangeFormulario(event) {
    let usrs = this.state.usrModificado;
    switch (event.target.id) {
      case "Inputcorreo":
        usrs.usrCorreo = event.target.value;
        //console.log(event.target.value);
        if (this.props.datosUsuario.loginHasError) {
          this.props.limpiarDatos();
        }

        break;
      case "Inputcontrasena":
        usrs.usrContrasena = event.target.value;
        if (this.props.datosUsuario.loginHasError) {
          this.props.limpiarDatos();
        }
        break;

      default:
        break;
    }

    this.setState({
      usrModificado: usrs,
      mensajeError: false,
      mensaje: ``
    });
  }

  render() {
    const renderStatus = () => {
      let isLoading = this.props.datosUsuario.loginIsLoading //? false : this.props.datosUsuario.loginIsLoading;
      let logIn =  this.props.datosUsuario.dataUsuario.userIsLoggedIn;

      console.log(this.props, isLoading)
      let usrModificado = this.state.usrModificado;
      let show = "login";
      if (logIn) show = "redireccion";


      switch (show) {
        case "recuperar":
          return (
            <main className="bg-light">
              <Row style={{ height: "100vh", justifyContent: "center", alignItems: "center", }} >
                <Col md={6} lg={4}>
                  <Card body>
                    <Login
                      email={this.state.email}
                      onIniciarSesion={this.handleIniciarSesion}
                      handleCambiarContrasenia={this.handleCambiarContrasenia}
                      usr={usrModificado}
                      vacios={this.state.vacios}
                    />
                  </Card>
                </Col>
              </Row>
            </main>
          );
        case "login":
          return (
            <LoadingScreen
              loading={isLoading}
              bgColor="#f1f1f1"
              spinnerColor="#001871"
              textColor="#676767"
              logoSrc={logo}
              text="Iniciando sesión"
            >
              <main className="bg-light">
                <Row style={{ height: "100vh", justifyContent: "center", alignItems: "center" }} >
                <Col lg={8} md={6} sm={6} xs={12}>
                    <Card body className={"login-sin-padding"}>
                     <Row style={{marginLeft:"0px", marginRight:"0px"}}>
                        <Col lg={4} md={12} className={"img-login-interfaz-background"}>
                          <img alt='' src={muneca} className={"img-login-interfaz-muneca"} />
                        </Col>
                        <Col lg={8} md={12} sm={12} xs={12} style = {{display:'flex'}}>
                          <div className={"centrar-formulario"}>
                            <Login
                              onSelectIniciarSesion={this.handleIniciarSesion}
                              onChangeFormulario={this.onChangeFormulario}
                              datosUsuario={this.props.datosUsuario}
                              usr={usrModificado}
                              vacios={this.state.vacios}
                            />
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={12} md={12} sm={12} xs={12}>
                          <div className="footer-login">
                            <a href="https://www.aig.com.ec/privacidad" target="_blank" style={{ color: "#ffff", }}>POLÍTICA DE PRIVACIDAD</a>
                          </div>
                        </Col>
                      </Row>
                    </Card>
                  </Col>
                </Row>
              </main>
            </LoadingScreen>
          );
        default:
          return null;
      }
    };

    return renderStatus();
  }
}

const mapStateToProps = state => ({
  //userIsLoggedIn: state.datosUsuarios.dataUsuario.userIsLoggedIn,
  datosUsuario: state.datosUsuarios
});

const mapDispatchToProps = dispatch => {
  return {
    loginUsuario: dataLogin => dispatch(loginFetch(dataLogin)),
    limpiarDatos: () => dispatch(limpiarLogin())
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ContainerLogin)
);
